export default {
  DriverLoginPage: {
    description: 'Please confirm the last 4 digits of your phone number',
    descriptionForUnauthorized: 'To log in, follow the link from the SMS',
    note: {
      text: "By proceeding with this process I agree to Haul's",
      link: 'TOS and Privacy policy',
    },
    btn: {
      submit: 'Continue',
    },
  },
};
